export const NEWSLETTER_SUBSCRIBE_VERIFIED = 'NEWSLETTER_SUBSCRIBE_VERIFIED';

export const newsletterSubscribeVerified = (email: string) => ({
  type: NEWSLETTER_SUBSCRIBE_VERIFIED,
  email,
});

export default {
  newsletterSubscribeVerified,
};
